// extracted by mini-css-extract-plugin
module.exports = {"gap":"1rem","desktopGap":"2rem","itemsGrid":"key-features_itemsGrid__uALKa","item":"key-features_item__zGpu2"};